import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import Prices from "../components/Pricing/Prices";

export default function PricingPage({ data }) {
  const vehicles = data.vehicles;

  return (
    <>
      <SEO title="Pricing" />
      <Hero
        title="affordable pricing for everyone"
        subtitle="Choosing Car Wash is a constant process in the life of every motorist. We try to give you only positive emotions. Entrust your car cleaning to our professionals."
      />
      <Prices vehicles={vehicles} />
    </>
  );
}
export const query = graphql`
  {
    vehicles: allSanityVehicle {
      edges {
        node {
          id
          name
          services {
            _key
            title
            price
          }
        }
      }
    }
  }
`;
